(() => {
  const root = document.body.dataset.scRoot || '/';
  const copy = document.body.dataset;
  const cart = document.getElementById('sc-cart');
  let busy = false;
  const setCartBusy = value => {
    busy = value;
    if (!cart) return;
    cart.setAttribute('aria-busy', String(value));
    cart.querySelectorAll('[data-sc-cart-qty],button[name="checkout"]').forEach(button => { button.disabled = value; });
  };
  const status = document.getElementById('sc-global-status');
  const announce = text => { if (status) status.textContent = text; };
  const restoreFocus = dialog => { if (dialog.scReturnFocus?.isConnected && !dialog.scReturnFocus.disabled) dialog.scReturnFocus.focus(); };
  const close = dialog => { if (dialog?.open) { dialog.close(); restoreFocus(dialog); } };
  const open = (dialog, trigger = document.activeElement) => { if (!dialog || typeof dialog.showModal !== 'function') return false; if (!dialog.open) { dialog.scReturnFocus = trigger; dialog.showModal(); } return true; };
  function applyCart(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const next = parsed.querySelector('[data-sc-cart]');
    if (!cart || !next) throw new Error(copy.scError);
    cart.querySelector('[data-sc-cart-inner]').replaceWith(next.querySelector('[data-sc-cart-inner]'));
    setCartBusy(busy);
    cart.dataset.count = next.dataset.count;
    document.querySelectorAll('[data-sc-count]').forEach(el => { el.textContent = next.dataset.count; });
    if (cart.open && !cart.contains(document.activeElement)) cart.querySelector('[data-sc-close]')?.focus();
  }
  async function refreshCart() {
    const response = await fetch(root + '?sections=shezi-cart', { credentials: 'same-origin' });
    if (!response.ok) throw new Error(copy.scError);
    const sections = await response.json();
    if (!sections['shezi-cart']) throw new Error(copy.scError);
    applyCart(sections['shezi-cart']);
  }
  async function mutate(endpoint, payload) {
    const response = await fetch(root + 'cart/' + endpoint + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ ...payload, sections: ['shezi-cart'], sections_url: root })
    });
    let result;
    try { result = await response.json(); }
    catch { throw new Error(copy.scError); }
    if (!response.ok) throw new Error(result.description || result.message || copy.scError);
    if (result.sections?.['shezi-cart']) applyCart(result.sections['shezi-cart']);
    else await refreshCart();
    document.dispatchEvent(new CustomEvent('sc:cart-updated'));
    return result;
  }
  document.querySelectorAll('.sc-dialog').forEach(dialog => {
    dialog.addEventListener('close', () => { if (!dialog.open) restoreFocus(dialog); });
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(dialog); });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const dialog = document.querySelector('.sc-dialog[open]');
    if (!dialog) return;
    const focusables = Array.from(dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]')).filter(el => el.getClientRects().length > 0);
    const first = focusables[0]; const last = focusables[focusables.length-1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });
  document.addEventListener('click', async event => {
    const opener = event.target.closest('[data-sc-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.scOpen);
      if (open(dialog, opener)) {
        event.preventDefault();
        if (dialog === cart && !busy) {
          setCartBusy(true);
          try { await refreshCart(); }
          catch { const message = cart.querySelector('[data-sc-cart-message]'); if (message) message.textContent = copy.scError; }
          finally { setCartBusy(false); }
        }
      }
      return;
    }
    const closer = event.target.closest('[data-sc-close]');
    if (closer) { close(closer.closest('dialog')); return; }
    const step = event.target.closest('[data-sc-step]');
    if (step) {
      const input = step.closest('[data-sc-quantity]').querySelector('input');
      const value = Math.max(1, Number(input.value) || 1);
      input.value = Math.max(1, value + Number(step.dataset.scStep));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const quantityButton = event.target.closest('[data-sc-cart-qty]');
    if (quantityButton && !busy) {
      const key = quantityButton.closest('[data-sc-line]').dataset.scLine;
      const quantity = Number(quantityButton.dataset.scCartQty);
      const previousAction = quantityButton.textContent.trim();
      let focusTarget = quantityButton;
      setCartBusy(true);
      try {
        await mutate('change', { id: key, quantity });
        announce(copy.scUpdated);
        const remaining = Array.from(cart.querySelectorAll('[data-sc-line]')).find(el => el.dataset.scLine === key);
        focusTarget = Array.from(remaining?.querySelectorAll('[data-sc-cart-qty]') || []).find(el => el.textContent.trim() === previousAction) || cart.querySelector('[data-sc-close]');
      } catch (error) {
        const message = cart.querySelector('[data-sc-cart-message]');
        if (message) message.textContent = error.message;
      } finally { setCartBusy(false); }
      if (focusTarget?.isConnected) focusTarget.focus();
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-sc-buy]');
    if (!form || !cart || typeof cart.showModal !== 'function') return;
    event.preventDefault();
    if (busy) return;
    const button = form.querySelector('button[type="submit"]');
    const message = form.querySelector('[data-sc-message]');
    const original = button.innerHTML;
    const data = new FormData(form);
    const quantity = Math.max(1, Number(data.get('quantity')) || 1);
    setCartBusy(true); button.disabled = true; button.textContent = copy.scAdding;
    if (message) message.textContent = '';
    try {
      await mutate('add', { id: Number(data.get('id')), quantity });
      button.disabled = false;
      open(cart, button);
      announce(copy.scAdded);
    } catch (error) {
      if (message) message.textContent = error.message;
      announce(error.message);
    } finally { setCartBusy(false); button.disabled = false; button.innerHTML = original; }
  });
  document.addEventListener('click', event => {
    const dialog = event.target.closest('dialog');
    if (dialog && event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close(dialog);
    }
    if (event.target.closest('.sc-menu nav a')) close(document.getElementById('sc-mobile-menu'));
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-sc-quantity] input')) event.target.value = Math.max(1, Number(event.target.value) || 1);
  });
  try {
    let cls = 0;
    new PerformanceObserver(list => {
      const entries = list.getEntries(); const last = entries[entries.length - 1];
      if (last) document.documentElement.dataset.scLcp = String(Math.round(last.startTime));
    }).observe({ type: 'largest-contentful-paint', buffered: true });
    new PerformanceObserver(list => {
      list.getEntries().forEach(entry => { if (!entry.hadRecentInput) cls += entry.value; });
      document.documentElement.dataset.scCls = cls.toFixed(4);
    }).observe({ type: 'layout-shift', buffered: true });
    let interaction = 0;
    new PerformanceObserver(list => {
      list.getEntries().forEach(entry => { if (entry.interactionId) interaction = Math.max(interaction, entry.duration); });
      document.documentElement.dataset.scInteractionMax = String(interaction);
    }).observe({ type: 'event', buffered: true, durationThreshold: 16 });
  } catch {}
})();
